/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Stack_TitleInputs */

const cs_builder_stack_title = /** @type {(inputs: Builder_Stack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásobník dokumentu`)
};

const en_builder_stack_title = /** @type {(inputs: Builder_Stack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document stack`)
};

/**
* | output |
* | --- |
* | "Document stack" |
*
* @param {Builder_Stack_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_stack_title = /** @type {((inputs?: Builder_Stack_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Stack_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_stack_title(inputs)
	return cs_builder_stack_title(inputs)
});